import { createSelector } from "reselect";
const selector = (state) => state.nomenclators;

export default createSelector([selector], (data) => data);